import { createContext } from 'react';
var IconContext = /*#__PURE__*/createContext({});
export default IconContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/es/components/Context.js
// module id = 49
// module chunks = 0